import { Dispatch, FC, SetStateAction } from 'react'
import ReactCodeInput from '@acusti/react-code-input'
import Button from 'react-bootstrap/Button'

import { isIOS } from 'share/utils/isiOs'
import { VerifyUpdatedEmailAddressVariables } from 'share/mutations/account'
import {
  CodeVerificationContainer,
  CodeVerificationSend,
  CodeVerifyWithinInfo,
  iOSCodeInputStyle
} from 'components/atoms/InputFields/CodeVerification'
import { ButtonsContainer } from 'components/features/dashboard/questionnaire/QuestionnareForm/styles'
import { TwoBtnsContainer } from 'components/atoms/Layout'

const style = !isIOS ? {} : iOSCodeInputStyle

interface Props {
  verifyUpdatedEmailAddressHelper(
    verifyUpdatedEmailAddressVariables: VerifyUpdatedEmailAddressVariables
  ): void
  enteredCode: string
  enteredCodeComplete: boolean
  resendUpdatedEmailAddressCodeHelper(): void
  setEnteredCode: Dispatch<SetStateAction<string>>
  setEnteredCodeComplete: Dispatch<SetStateAction<boolean>>
  cancelUpdatedEmailAddressHelper(): void
}

const UserProfileVerifyEmailAddressForm: FC<Props> = ({
  verifyUpdatedEmailAddressHelper,
  enteredCode,
  enteredCodeComplete,
  resendUpdatedEmailAddressCodeHelper,
  setEnteredCode,
  setEnteredCodeComplete,
  cancelUpdatedEmailAddressHelper
}) => {
  const onSubmit = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault()

    const input: VerifyUpdatedEmailAddressVariables = {
      verifyEmailAddressData: {
        code: enteredCode
      }
    }
    verifyUpdatedEmailAddressHelper(input)
  }

  const handleCodeChange = (val: string) => {
    if (val?.length === 6) {
      setEnteredCode(val)
      setEnteredCodeComplete(true)
      return
    }

    setEnteredCodeComplete(false)
  }

  async function onCancel() {
    cancelUpdatedEmailAddressHelper()
  }

  return (
    <CodeVerificationContainer data-testid='user-profile-verify-email-address-container'>
      <p>Please enter the verification code below.</p>
      <ReactCodeInput
        autoFocus
        className='ui-code-verification-inputs'
        fields={6}
        inputMode='numeric'
        inputStyle={style}
        name='verifyEmailAddress'
        type='number'
        value={enteredCode}
        onChange={handleCodeChange}
      />
      <CodeVerifyWithinInfo>
        Please verify within 5 minutes.
      </CodeVerifyWithinInfo>
      <CodeVerificationSend data-testid='user-profile-verify-email-address-send'>
        Didn't get a code?{' '}
        <span
          role='button'
          onClick={() => resendUpdatedEmailAddressCodeHelper()}
          data-testid='user-profile-verify-email-address-resend-code-button'
        >
          Send it again
        </span>
      </CodeVerificationSend>

      <ButtonsContainer
        className='p-0 btns-container'
        style={{ marginTop: '2rem' }}
      >
        <TwoBtnsContainer>
          <Button
            variant='outline-secondary'
            onClick={onCancel}
            className='ui-button-with-spinner'
            data-testid='user-profile-verify-email-address-cancel-button'
          >
            Cancel
          </Button>
          <Button
            className='ui-button-with-spinner'
            disabled={!enteredCodeComplete}
            type='submit'
            onClick={onSubmit}
            data-testid='user-profile-verify-email-address-next-button'
          >
            Next
          </Button>
        </TwoBtnsContainer>
      </ButtonsContainer>
    </CodeVerificationContainer>
  )
}

export default UserProfileVerifyEmailAddressForm
